module.exports = __webpack_public_path__ + "img/智慧党建AI助手 (1).d8767ecc.png";